// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","amenities__item":"amenities__item-Eama7","amenities__item_unavailable":"amenities__item_unavailable-3JOOa","amenities":"amenities-24BLZ"};